import {
  PieChart,
  Pie,
  Cell,
  Tooltip,
  ResponsiveContainer,
  Legend,
} from "recharts";
import { Spinner } from "@/shared/components/ui/spinner";
import type { RentalStatusCount } from "../../types/dashboard.types";

interface DarkTooltipProps {
  active?: boolean;
  payload?: Array<{ name: string; value: number; payload: RentalStatusCount }>;
}

const DarkTooltip = ({ active, payload }: DarkTooltipProps) => {
  if (!active || !payload?.length) return null;
  const d = payload[0];
  return (
    <div
      style={{
        backgroundColor: "#0f172a",
        border: "1px solid #1e293b",
        borderRadius: "10px",
        padding: "10px 14px",
        fontSize: 12,
        lineHeight: 1.8,
        boxShadow: "0 8px 24px rgba(0,0,0,0.5)",
      }}
    >
      <p
        style={{
          color: "#94a3b8",
          fontWeight: 500,
          marginBottom: 4,
          fontSize: 11,
        }}
      >
        {d.name}
      </p>
      <p style={{ color: d.payload.color }}>
        <span style={{ color: "#64748b", marginRight: 8 }}>Locações</span>
        {d.value}
      </p>
    </div>
  );
};

interface RentalStatusChartProps {
  data: RentalStatusCount[];
  loading?: boolean;
}

export const RentalStatusChart = ({
  data,
  loading,
}: RentalStatusChartProps) => (
  <div className="rounded-xl border bg-card p-5 shadow-sm">
    <p className="mb-1 text-sm font-semibold text-foreground">
      Status dos aluguéis
    </p>
    <p className="mb-4 text-xs text-muted-foreground">
      Na rua e Incompleto = estado atual&nbsp;·&nbsp;Finalizado = semana
      corrente
    </p>

    {loading ? (
      <div className="flex h-[210px] items-center justify-center">
        <Spinner className="size-6" />
      </div>
    ) : data.length === 0 ? (
      <div className="flex h-[210px] items-center justify-center text-sm text-muted-foreground">
        Sem locações ativas no momento
      </div>
    ) : (
      <ResponsiveContainer width="100%" height={210}>
        <PieChart margin={{ top: 4, right: 4, bottom: 4, left: 4 }}>
          <Pie
            data={data}
            dataKey="count"
            nameKey="label"
            cx="50%"
            cy="42%"
            innerRadius={44}
            outerRadius={68}
            paddingAngle={3}
            strokeWidth={0}
          >
            {data.map((entry) => (
              <Cell key={entry.status} fill={entry.color} />
            ))}
          </Pie>
          <Tooltip content={<DarkTooltip />} />
          <Legend
            iconType="circle"
            iconSize={7}
            wrapperStyle={{ fontSize: 11, color: "#64748b", paddingTop: 8 }}
          />
        </PieChart>
      </ResponsiveContainer>
    )}
  </div>
);
